import { createContext } from "react";

const MessageContext2 = createContext([]);

export default MessageContext2;
